import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../../';
import { ContextConsumer } from './Context';

var SearchInput = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchInput, _React$Component);

  var _super = _createSuper(SearchInput);

  function SearchInput() {
    var _this;

    _classCallCheck(this, SearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      phrase: ''
    });

    _defineProperty(_assertThisInitialized(_this), "setSearchPhrase", function () {
      var phrase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props = _this.props,
          searchResultsRef = _this$props.searchResultsRef,
          setSearchPhrase = _this$props.setSearchPhrase,
          onChangeSearch = _this$props.onChangeSearch;

      _this.clearTimer();

      searchResultsRef.current.scrollTop = 0;
      setSearchPhrase(phrase.trim());

      if (typeof onChangeSearch === 'function') {
        onChangeSearch(phrase);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedSetSearchPhrase", function (_ref) {
      var target = _ref.target;
      var phrase = target.value;

      _this.setState({
        phrase: phrase
      });

      _this.clearTimer();

      _this.timer = setTimeout(function () {
        return _this.setSearchPhrase(phrase);
      }, 250);
    });

    return _this;
  }

  _createClass(SearchInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var phrase = this.state.phrase;
      var _this$props2 = this.props,
          _this$props2$placehol = _this$props2.placeholder,
          placeholder = _this$props2$placehol === void 0 ? 'Search…' : _this$props2$placehol,
          inputProps = _this$props2.inputProps,
          forwardedRef = _this$props2.forwardedRef;
      return /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-search-input-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('cloud-ui-search-input-icon', {
          inactive: !phrase
        })
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "search"
      })), /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
        autoComplete: "off" // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: true,
        className: "cloud-ui-search-input",
        onChange: this.debouncedSetSearchPhrase,
        placeholder: placeholder,
        ref: forwardedRef,
        spellCheck: false,
        type: "text",
        value: phrase
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // ensure phrase get cleared properly when search is closed
      if (!props.searchActive && !props.searchPhrase && state.phrase) {
        return {
          phrase: props.searchPhrase
        };
      }

      return null;
    }
  }]);

  return SearchInput;
}(React.Component);

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref2) {
    var searchActive = _ref2.searchActive,
        searchPhrase = _ref2.searchPhrase,
        setSearchPhrase = _ref2.setSearchPhrase,
        searchResultsRef = _ref2.searchResultsRef;
    return /*#__PURE__*/React.createElement(SearchInput, _extends({}, props, {
      searchActive: searchActive,
      searchPhrase: searchPhrase,
      searchResultsRef: searchResultsRef,
      setSearchPhrase: setSearchPhrase,
      forwardedRef: ref
    }));
  });
});